import { Image } from "antd";
import { LoaderIcon } from "config/IconConfig";

const Loader = () => (
  <div style={{ width: "100%", textAlign: "center", marginTop: 50 }}>
    <Image
      src={LoaderIcon}
      alt="Loader"
      preview={false}
      style={{ textAlign: "center" }}
    />
  </div>
);

export default Loader;
